/* tslint:disable */
/* eslint-disable */
/**
 * Your Project API
 * Your project description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Category,
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedCategoryList
 */
export interface PaginatedCategoryList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCategoryList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCategoryList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCategoryList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Category>}
     * @memberof PaginatedCategoryList
     */
    results?: Array<Category>;
}

export function PaginatedCategoryListFromJSON(json: any): PaginatedCategoryList {
    return PaginatedCategoryListFromJSONTyped(json, false);
}

export function PaginatedCategoryListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedCategoryList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CategoryFromJSON)),
    };
}

export function PaginatedCategoryListToJSON(value?: PaginatedCategoryList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CategoryToJSON)),
    };
}

